module.exports = __webpack_public_path__ + "img/Z86Q_12.8f2b6f38.jpg";